
import * as constants from '../constants/ticketConstants';
//grab the tickets for each user role...
const ticketReducer = (state = {tickets:[],errMsg:''},action)=>{
      
      switch (action.type)
      {
            case constants.TICKET_FETCH:

                return {
                   ...state,
                   tickets:{
                        ...action.payload
                   }
                };

            case constants.TICKET_CREATE:
                 return {
                  ...state,
                  tickets:[
                        ...state.tickets,
                        action.payload
                  ]
                };

            case constants.TICKET_JOIN:
                  
                  return {
                        ...state,
                        tickets: [
                              ...state.tickets,
                              action.payload
                        ]
                  };
                  
            case constants.TICKET_UPDATE:

                  const newTickets = state.tickets.map(x=>{

                        return x._id === action.payload._id ? action.payload : x;
                  });

                  return {
                        ...state,
                        tickets:[...newTickets]
                  }

            default:
                return state;
      }


};

export default ticketReducer;